import { createContext, useContext } from 'react';

import { PatronSessionState } from '@app/components';
import { SetState } from '@app/constants';

type AuthenticateToken = (token: string, redirectRoute: string) => void;

export interface AppContextProps {
  patronSession: PatronSessionState;
  isLoggedIn: boolean;
  bannerMessage: string | undefined;
  authenticateToken: AuthenticateToken;
  setPatronSession: SetState<PatronSessionState>;
}

export const AppContext = createContext<AppContextProps>(null!);

export const useAppContext = (): AppContextProps => {
  return useContext(AppContext);
};
